const map = {
	"./clarendon-bt-light/clarendon-bt-light-webfont.woff": 8036,
	"./clarendon-bt-light/clarendon-bt-light-webfont.woff2": 2174,
	"./clarendon/clarendon-regular-webfont.woff": 4087,
	"./clarendon/clarendon-regular-webfont.woff2": 8263,
	"./hackney/Hackney-Bold.ttf": 9212,
	"./hanoded-formosa-upright/hanoded-formosa-upright-webfont.woff": 8670,
	"./hanoded-formosa-upright/hanoded-formosa-upright-webfont.woff2": 1048,
	"./hanoded-formosa/hanoded-formosa-webfont.woff": 750,
	"./hanoded-formosa/hanoded-formosa-webfont.woff2": 7192,
	"./interstate-cond-bold/interstate-cond-bold-webfont.woff": 776,
	"./interstate-cond-bold/interstate-cond-bold-webfont.woff2": 9482,
	"./interstate-cond-mono-bold/interstate-cond-mono-bold-webfont.woff": 9966,
	"./interstate-cond-mono-bold/interstate-cond-mono-bold-webfont.woff2": 7256,
	"./interstate-cond-mono-regular/interstate-cond-mono-regular-webfont.woff": 9402,
	"./interstate-cond-mono-regular/interstate-cond-mono-regular-webfont.woff2": 6908,
	"./kaisei/KaiseiHarunoUmi-Bold.ttf": 9524,
	"./kaisei/KaiseiHarunoUmi-Medium.ttf": 9948,
	"./kaisei/KaiseiHarunoUmi-Regular.ttf": 8315,
	"./kaisei/KaiseiTokumin-Regular.woff": 4392,
	"./neutraface-text/NeutrafaceText-Bold.ttf": 5811,
	"./neutraface-text/NeutrafaceText-Book.ttf": 4193,
	"./neutratext/NeutraText-Bold.otf": 9569,
	"./neutratext/NeutraText-BoldItalic.otf": 6845,
	"./neutratext/NeutraText-Book.otf": 355,
	"./neutratext/NeutraText-BookItalic.otf": 3571,
	"./neutratext/NeutraText-Demi.otf": 5399,
	"./neutratext/NeutraText-DemiItalic.otf": 4647,
	"./neutratext/NeutraText-Light.otf": 6706,
	"./neutratext/NeutraText-LightItalic.otf": 2766,
	"./nunito/Nunito-Bold.ttf": 8076,
	"./nunito/Nunito-Regular.ttf": 4435,
	"./recoleta/Recoleta-Regular.ttf": 6035,
	"./roboto-mono/LICENSE.txt": 2862,
	"./roboto-mono/RobotoMono-Bold.ttf": 5283,
	"./roboto-mono/RobotoMono-BoldItalic.ttf": 7835,
	"./roboto-mono/RobotoMono-Italic.ttf": 1922,
	"./roboto-mono/RobotoMono-Light.ttf": 5570,
	"./roboto-mono/RobotoMono-LightItalic.ttf": 2462,
	"./roboto-mono/RobotoMono-Medium.ttf": 3319,
	"./roboto-mono/RobotoMono-MediumItalic.ttf": 2127,
	"./roboto-mono/RobotoMono-Regular.ttf": 5962,
	"./roboto-mono/RobotoMono-Thin.ttf": 2207,
	"./roboto-mono/RobotoMono-ThinItalic.ttf": 4407,
	"./watchhouse/bold.otf": 8185,
	"./watchhouse/regular.otf": 4010,
	"./work-sans/WorkSans-Black.ttf": 551,
	"./work-sans/WorkSans-Bold.ttf": 4767,
	"./work-sans/WorkSans-ExtraBold.ttf": 4297,
	"./work-sans/WorkSans-Medium.ttf": 7664,
	"./work-sans/WorkSans-Regular.ttf": 7894
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8205;